import React from 'react';

const OffcanvasRight = ({ title, children, open, onClose, widthPct = 75 }) => {
  if (!open) return null;
  const width = `${Math.min(75, Math.max(30, widthPct))}%`;
  return (
    <div className="offcanvas offcanvas-end show" tabIndex="-1" style={{ visibility: 'visible', width }}>
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">{title}</h5>
        <button type="button" className="btn-close text-reset" onClick={onClose}></button>
      </div>
      <div className="offcanvas-body" style={{ overflow: 'auto' }}>
        {children}
      </div>
    </div>
  );
};

export default OffcanvasRight;



